import React, { Component } from 'react'

import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { API_URL } from 'state/api'

import SectionControls from 'components/controls/section-controls'

import DashboardTasks from 'sections/dashboard/dashboard-tasks'
import StatusOverview from './status-overview'
import ProgressUpdate from './progress-update'
import ProjectPulse from './project-pulse'

import { getCurrentUser } from 'state/selectors'

import DashboardTimeTrackingOverview from 'sections/dashboard/dashboard-time-tracking-overview'

import moment from 'moment'
import { 
    doSort,
    getPrimaryColumnValue
} from 'utils'

class ProjectReporting extends Component {
    state = {
        hasMounted: false,  // once again, transitions inexplicably break without this...
        isPDFLoading: false,
        isCSVLoading: false,
        isTimeTrackingLoading: false
    }

    componentDidMount = _ => {
        setTimeout(_ => {
            this.setState({
                hasMounted: true
            })
        },50)
    }

    getTasks = type => {
        const {
            currentProject,
            allMilestones,
            allTasks
        } = this.props

        const tasks = []
        let allTaskObjects = []

        currentProject.milestones.forEach(milestoneId => {
            const milestone = allMilestones[milestoneId]

            if(milestone && milestone.tasks){
                milestone.tasks.forEach(taskId => {
                    const task = allTasks[taskId]

                    const statusId = getPrimaryColumnValue('status', task, currentProject)

                    if(statusId !== 3){
                        allTaskObjects.push(task)
                    }
                })
            }
        })

        switch(type){
            case 'recent':
                allTaskObjects = doSort(allTaskObjects, 'date', 'created_at', true)

                allTaskObjects && allTaskObjects.some(taskObject => {
                    tasks.push(taskObject.id)

                    if(tasks.length == 10){
                        return true
                    }
                })

                break
            case 'upcoming':
                allTaskObjects.reverse()

                allTaskObjects.forEach(task => {
                    const dates = getPrimaryColumnValue('date', task, currentProject)

                    if(dates && dates.end_date && moment(dates.end).isAfter(moment().startOf('day'))){
                        tasks.push(task.id)
                    }
                })

                break
        }

        return tasks
    }

	exportReport = _ => {
		const {
			isPDFLoading
        } = this.state
        
        const {
            currentProject
        } = this.props

		if(isPDFLoading){
			return
		}

		this.setState({
			isPDFLoading: true
		}, _ => {
			setTimeout(_ => {
				this.setState({
					isPDFLoading: false
				})
			},2000)
		})

		const anchor = document.createElement('a')
		anchor.href = API_URL+'/project/export/'+currentProject.id

		document.body.appendChild(anchor)
		anchor.click()
		anchor.remove()
    }
    
    exportData = _ => {
        const {
            currentProject
        } = this.props

        const {
            isCSVLoading
        } = this.state

        if(isCSVLoading){
            return
        }

        this.setState({
			isCSVLoading: true
		}, _ => {
			setTimeout(_ => {
				this.setState({
					isCSVLoading: false
				})
			},2000)
		})

        const anchor = document.createElement('a')
        anchor.href = API_URL+'/project/'+currentProject.id+'/getExport'

        document.body.appendChild(anchor)
        anchor.click()
        anchor.remove()
    }

    exportTimeTrackingByMonth = _ => {
        const {
            isTimeTrackingLoading
        } = this.state
        
        const {
            currentProject
        } = this.props

        if(isTimeTrackingLoading){
            return
        }

        this.setState({
            isTimeTrackingLoading: true
        }, _ => {
            setTimeout(_ => {
                this.setState({
                    isTimeTrackingLoading: false
                })
            },2000)
        })

        const anchor = document.createElement('a')
        anchor.href = API_URL+'/project/'+currentProject.id+'/getTimeTrackingExport'

        document.body.appendChild(anchor)
        anchor.click()
        anchor.remove()
    }

	render() {
        const {
            currentProject,
            allMilestones,
            allTasks,
            allStatuses,
            allProjects,
            allSessions,
            allTeams,
            applicableUsers,
            loading,
            userData
        } = this.props

        const {
            hasMounted,
            isPDFLoading,
            isCSVLoading,
            isTimeTrackingLoading
        } = this.state

		const buttonProps = [
            {
			    size: 'big',
			    level: 'low',
			    label: 'Export project report',
			    icon: 'file-pdf-o',
			    callback: this.exportReport,
                isLoading: isPDFLoading,
            },{
                size: 'big',
                level: 'low',
                label: 'Export project data',
                icon: 'file-excel-o',
                callback: this.exportData,
                isLoading: isCSVLoading
            }
        ]

        if(currentProject && currentProject.account_id === 1 && currentProject.has_timing){
            buttonProps.push({
                size: 'big',
                level: 'low',
                label: 'Export time tracking by month',
                icon: 'clock',
                callback: this.exportTimeTrackingByMonth,
                isLoading: isTimeTrackingLoading
            })
        }

        const commonProps = {
            project: currentProject,
            allMilestones,
            allTasks,
            applicableUsers,
            userData
        }

        return (
            <div className="project-reporting dashboard-container">
                <SectionControls 
                    buttons={buttonProps} 	
                />
                { hasMounted ?
                    <main className="clear">
                        <div className="row">
                            <ProjectPulse
                                {...commonProps}
                            />
                        </div>
                        <div className="row">
                            <div className="right-column use-absolute">
                                <StatusOverview 
                                    {...commonProps}
                                    allStatuses={allStatuses}
                                    loading={loading}
                                />
                            </div>
                            <div className="left-column">
                                <div className="widget box dashboard-tasks">
                                    <DashboardTasks 
                                        {...commonProps}
                                        allProjects={allProjects} 
                                        recentlyAdded={this.getTasks('recent')} 
                                        upcoming={this.getTasks('upcoming')} 
                                        togglePreference={0}
                                        type="reporting"
                                        loading={loading}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="left-column">
                                <DashboardTimeTrackingOverview
                                    {...commonProps}
                                    allTeams={allTeams}
                                    type="allocation"
                                    thisUser={userData}
                                    isLoading={loading}
                                />
                            </div>
                            <div className="right-column use-absolute">
                                <ProgressUpdate
                                    {...commonProps}
                                    allSessions={allSessions}
                                />
                            </div>
                        </div>
                    </main>
                : null }
            </div>
        )
	}
}

const mapStateToProps = state => { 
    return {
        userData: getCurrentUser(state),
        allProjects: state.account.entities.projects,
        allMilestones: state.account.entities.milestones,
        allTasks: state.account.entities.tasks,
        allStatuses: state.account.entities.statuses,
        allUsers: state.account.entities.users,
        allTeams: state.account.entities.teams,
        allSessions: state.account.entities.sessions
    }
}

export default withRouter(connect(mapStateToProps, {

 })(ProjectReporting))
